export const QUEUE_KEYS = [
  { key: 'fast', label: 'Fast queue' },
  { key: 'slow', label: 'Slow queue' },
  { key: 'translate', label: 'Translate queue' },
  { key: 'qrcode', label: 'QR code queue' },
  { key: 'speech', label: 'Speech queue' },
]

export const QUEUE_PROMPT_FIELDS = {
  fast: { field: 'prompt', label: 'Image to Receipt without products Prompt' },
  slow: { field: 'product_prompt', label: 'Image to Receipt with products Prompt' },
  translate: { field: 'product_translation_prompt', label: 'Product Categorization Prompt' },
  qrcode: { field: 'qrcode_prompt', label: 'QR Code link selectors extraction prompt' },
  speech: { field: 'speech_prompt', label: 'Speech to Receipt Prompt' },
}

export const buildQueueState = (defaultValue = true) => (
  QUEUE_KEYS.reduce((acc, queue) => ({ ...acc, [queue.key]: defaultValue }), {})
)

export function getQueuePromptLabel(queueKey, translate) {
  const label = QUEUE_PROMPT_FIELDS[queueKey]?.label || 'Queue Prompt'
  return translate(label, label)
}
